import { yup } from '@framework/validation';
import { Dictionary } from 'lodash';
import { isParentWidgetScopeReadonly } from '../../../../validator/utils/parent-scope/isParentWidgetScopeReadonly';
import { IExpression } from '../../../expressions/IExpression';
import { mapReferenceToPath } from '../../../expressions/evaluate/mapReferenceToPath';
import { createEvaluationVariables } from '../../../expressions/evaluate/variables/IEvaluationVariables';
import { collectExpressionReferences } from '../../../expressions/references/collectExpressionReferences';
import { IParentWidgetScope } from '../../IWidgetType';

/**
 * Aggiunge il transform per i widget calcolati stringa/numero.
 * La evaluateFn è la funzione per calcolare il risultato dell'espressione
 * che verrà poi applicato al campo.
 */
export function setComputeTransform<T extends IExpression>(
  expression: T,
  parentScope: IParentWidgetScope,
  schema: yup.AnySchema,
  evaluateFn: (expression: T, variables: Dictionary<any>) => any,
) {
  // In Readonly, non applichiamo la trasformazione in quanto comunque
  // il campo non è modificabile e il valore corretto è quello consolidato.
  if (isParentWidgetScopeReadonly(parentScope)) return schema;

  const references = collectExpressionReferences(expression);
  const paths = references.map(r => mapReferenceToPath(r));

  return schema.parentWhen(
    paths,
    (values, schema: yup.AnySchema, context: any) => {
      const variables = createEvaluationVariables(references, values);

      const result = evaluateFn(expression, variables);

      // È fondamentale inserire un valore di default, altrimenti con `undefined`
      // il transform non viene eseguito per le logiche interne di Yup.
      // Utilizziamo `null` come valore di default, così che non sia un problema
      // il tipo di dato restituito dalla funzione di valutazione.
      return schema.default(null).transform(() => result);
    },
  );
}
